import NavigateBeforeIcon from "@mui/icons-material/ExpandLessRounded";
import NavigateNextIcon from "@mui/icons-material/ExpandMoreRounded";
import { IconButton, Stack, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import WorkflowActivityStatusTag from "./WorkflowActivityStatusTag";
import type { WorkflowStep } from "./workflowDetailsHelpers";
import { getActivityDisplayStatus, getDetailsTimeLabel, getWorkflowStepTitle } from "./workflowDetailsHelpers";
import WorkflowRunDetailsContext from "./WorkflowRunDetailsContext";

const isNextDisabled = (steps: WorkflowStep[], selectedStepIndex: number): boolean => {
  if (selectedStepIndex >= steps.length - 1) {
    return true;
  }

  const nextStep = steps[selectedStepIndex + 1];

  return (
    nextStep !== undefined &&
    nextStep.type === "activity" &&
    getActivityDisplayStatus(nextStep.activity) === "NotStarted"
  );
};

const WorkflowDetailPanelHeader = () => {
  const { steps, selectedStepIndex, selectStep, selectedStep, selectedActivity } = useDefinedContext(
    WorkflowRunDetailsContext,
    "WorkflowRunDetailsContext"
  );

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ alignItems: "center", px: 2, py: 1, flexShrink: 0, "& .MuiChip-root": { flexShrink: 0 } }}
    >
      <IconButton disabled={selectedStepIndex === 0} onClick={() => selectStep(selectedStepIndex - 1)}>
        <NavigateBeforeIcon />
      </IconButton>
      <IconButton disabled={isNextDisabled(steps, selectedStepIndex)} onClick={() => selectStep(selectedStepIndex + 1)}>
        <NavigateNextIcon />
      </IconButton>
      <Typography variant="subtitle1" noWrap>
        {selectedStep ? getWorkflowStepTitle(selectedStep) : ""}
      </Typography>
      <Typography variant="caption" color="textSecondary" sx={{ flexShrink: 0 }}>
        {selectedStepIndex + 1} of {steps.length}
      </Typography>
      {selectedActivity && <WorkflowActivityStatusTag status={getActivityDisplayStatus(selectedActivity)} />}
      <HorizontalFill />
      {selectedActivity && <Typography color="textSecondary">{getDetailsTimeLabel(selectedActivity)}</Typography>}
    </Stack>
  );
};

export default WorkflowDetailPanelHeader;
